import ErrorBoundary from '@/ErrorBoundary';
import GlobalProvider from './GlobalProvider';
import { PlayProvider } from './PlayProvider';
import RouterProvider from './RouterProvider';

function Providers() {
    return (
        <ErrorBoundary>
            <GlobalProvider>
                <PlayProvider>
                    <RouterProvider />
                </PlayProvider>
            </GlobalProvider>
        </ErrorBoundary>
    );
}

export default Providers;
